import React from 'react'
import { AppCardTitle, AppCrudTable, AppResultsSkeleton } from '@components'
import {
    executionDateColumn,
    historyColumn,
    idColumn,
    sitesColumn,
    runtimeColumn,
    userNameColumn
} from './columns'
import { useTable, useManageBatchStatusMultiple } from "../@hooks";
import GlobalExecutionToolbarSelect from "./Toolbar";


export default function GlobalExecutionsBatchTable() {
    const { isLoading, tableBatchData } = useTable()

    useManageBatchStatusMultiple()

    if (isLoading) return <AppResultsSkeleton/>

    return <AppCrudTable
            title={<AppCardTitle icon="clipboard-list" title="Batch Executions"/>}
            toolbarProps={{ actions: false }}
            data={tableBatchData}
            columns={[idColumn(),userNameColumn(),...sitesColumn(),executionDateColumn(), runtimeColumn(), ...historyColumn(),]}
            options={{
                selectableRows: 'multiple',
                customToolbarSelect: (selectedData, setSelectedRows) => <GlobalExecutionToolbarSelect
                    selectedData={selectedData}
                    setSelectedRows={setSelectedRows}/>
            }}
            setHeaderCellProps={() => ({ sx: { fontWeight: 'bold' } })}
            setBodyCellProps={() => ({ sx: { width: 250 } })}
        />
}